import { render, staticRenderFns } from "./AltaAplicado.vue?vue&type=template&id=8f1a5746&scoped=true&"
import script from "./AltaAplicado.vue?vue&type=script&lang=js&"
export * from "./AltaAplicado.vue?vue&type=script&lang=js&"
import style0 from "./AltaAplicado.vue?vue&type=style&index=0&id=8f1a5746&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f1a5746",
  null
  
)

export default component.exports